<template>

	<!-- Basic Box Row Wrap -->
	<div class="basic-box__row-wrap">

		<!--Row Item-->
		<div class="basic-box__row hr">
			<div class="basic-box__row-inner">

				<!--Time-->
				<div class="basic-box__row-item basic-box__row-item_time" v-show="today">
					{{visit.begin | time}}
				</div>

				<!--Time-->
				<div class="basic-box__row-item basic-box__row-item_time" v-show="!today">
					{{visit.begin | data('DD.MM')}}
				</div>

				<!--Avatar-->
				<div class="basic-box__row-item basic-box__row-item_avatar-wrap">
					<user-avatar :data="connectUser" :setClass="'basic-box__avatar'"></user-avatar>
				</div>

				<!--Name-->
				<div class="basic-box__row-item basic-box__row-item_name">
					{{connectUser.last_name}} {{connectUser.first_name}} {{connectUser.middle_name}}
				</div>

				<!--Buttons-->
				<div class="basic-box__row-item basic-box__btns">
							 <span class="basic-box__status bold" :class="calcStatusClass(visit.status)">
								 {{visit.status | status}}
							 </span>

					<button v-if="calcCanDoAct(visit)" class="basic-box__btn basic-box__btn_actions bold"
									@click.stop="doAct(true)">
						Действия
						<i class="basic-box__icon basic-box__icon_dark basic-box__icon_arrow_down icon ion-chevron-down"></i>

						<div class="outer_drop-menu" v-show="isDoAct" @click.stop="doAct(false)"></div>

						<!--Drop Menu-->
						<ul class="drop-menu" v-show="isDoAct">
							<li class="drop-menu__item"
									v-if="isDoctor && (visit.status == 'confirmed' || visit.status === 'not_confirmed')">
								<div @click="startVisit(visit)" class="drop-menu__link drop-menu__link_orange">
									Начать прием
								</div>
							</li>
							<li class="drop-menu__item"
									v-if="isDoctor && visit.status == 'came'">
								<div @click="continueVisit(visit)" class="drop-menu__link drop-menu__link_orange">
									Продолжить
								</div>
							</li>
							<li class="drop-menu__item" v-if="isDoctor" @click.stop="editEvent(visit)">
								<a class="drop-menu__link drop-menu__link_blue">Редактировать</a>
							</li>
							<!--<li class="drop-menu__item">-->
							<!--<a href="#" class="drop-menu__link drop-menu__link_lightblue">Перенести</a>-->
							<!--</li>-->
							<li class="drop-menu__item" @click.stop="cancelVisit(visit)">
								<div class="drop-menu__link drop-menu__link_gray">Отменить</div>
							</li>
						</ul>
						<!--Drop Menu End-->

					</button>
					<button v-else class="basic-box__btn-nonact">
						Нет действий
					</button>

					<button class="basic-box__btn basic-box__btn_details js-details bold" @click="isDetails = !isDetails">
						Детали
						<i class="basic-box__icon basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"></i>
					</button>
				</div>
			</div>

			<!--Description-->
			<div id="js-details-content" class="basic-box__descr">
				<p class="basic-box__text" v-show="visit.description">
					Коментарий:<span class="basic-box__text_comment">{{visit.description}}</span>
				</p>
				<div v-show="isDetails">
					<p class="basic-box__text">
						Дата: <span class="basic-box__text_date">{{visit.begin | data('DD.MM.YY HH:mm')}}</span>
					</p>

					<p class="basic-box__text" v-if="!isDoctor">
						Место: {{connectUser.phone}}
						<span class="basic-box__text_place">
							{{visit.clinic.name}} ({{visit.clinic.city.name}}, {{visit.clinic.street}} {{visit.clinic.house}})
						</span>
					</p>

					<p class="basic-box__text" v-else>
						Телефон:<span class="basic-box__text_phone">
						+{{connectUser.phone}}
					</span>
					</p>
				</div>

			</div>
		</div>
		<!--Row Item End-->

	</div>
	<!-- Basic Box Row Wrap -->

</template>

<script>
	import moment from 'moment'
	import _ from 'underscore'

	const classes = {
		'not_confirmed': 'status_not-confirmed',
		'confirmed': 'status_confirmed',
		'came': 'status_performing',
		'canceled': 'status_canceled',
		'not_appeared': 'status_absence',
		'completed': 'status_done'
	}

	export default {
		name: "VisitItem",
		props: ['event'],
		computed: {
			visit() {
				return this.event
			},
			today() {
				return moment().format('DD') === moment(this.visit.begin, 'X').format('DD')
			},
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			connectUser() {
				return this.isDoctor ? this.visit.users[0] : this.prepareDoctor(this.visit.workers[0])
			}
		},
		data() {
			return {
				isDetails: false,
				isDoAct: false
			}
		},
		methods: {
			calcStatusClass(status) {
				return [classes[status]]
			},
			doAct(bool) {
				this.isDoAct = !!bool
			},
			startVisit(visit) {
				visit.status = 'came'
				visit.id = visit._id

				this.$store.dispatch('agenda/update', visit).then(() => {
					this.$router.push({
						name: 'Card',
						query: {
							visit: visit._id, doctor: visit.workers[0]._id, patient: visit.users[0]._id
						}
					})
				})
			},
			continueVisit(visit) {
				this.$router.push({
					name: 'Card',
					query: {
						visit: visit._id, doctor: visit.workers[0]._id, patient: visit.users[0]._id
					}
				})
			},
			editEvent(event) {
				this.isDoAct = false
				this.$event.send('openEditModal', _.clone(event), event.workers[0])
			},
			cancelVisit(visit) {
				this.$event.send('openDetailsModal', visit, true)
				this.isDoAct = false
			},
			getDay(ts) {
				return moment(ts, 'X').format('DD')
			},
			calcCanDoAct(visit) {
				return visit.status === 'came' ||
					visit.status === 'confirmed' ||
					visit.status === 'not_confirmed'
			},
			prepareDoctor(doctor) {
				doctor.first_name = doctor.user_first_name
				doctor.last_name = doctor.user_last_name
				doctor.middle_name = doctor.user_middle_name

				doctor.attachment = doctor.user_attachment
				return doctor
			}
		}
	}
</script>

<style scoped>
	.outer_drop-menu {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// VisitItem.vue?a4e3c77c